import React from 'react';

import { ReactComponent as ChevronLeft } from '../../../assets/svg/chevron_left_balloon.svg';
import { ReactComponent as ChevronRight } from '../../../assets/svg/chevron_right.svg';
import { ReactComponent as KeepIcon } from '../../../assets/svg/keep_24px.svg';
import { ReactComponent as MapPinIcon } from '../../../assets/svg/place_24px.svg';
import styles from '../NewPointDetails.module.scss';

export type PointDetailsHeaderProps = {
    deviceName: string;
    deviceIconUrl?: string;
    imagePathFallback: string;
    showDeviceImage: boolean;
    setShowDeviceImage: (show: boolean) => void;
    existsPrevPoint?: boolean;
    existsNextPoint?: boolean;
    selectPrevPoint?: () => void;
    selectNextPoint?: () => void;
    setStatusMsg: (msg: string) => void;
    isEvent: boolean;
    msg: string;
    formattedAddress: string;
    isPinned: boolean;
};

export const PointDetailsHeader: React.FC<PointDetailsHeaderProps> = ({
    deviceName,
    deviceIconUrl,
    imagePathFallback,
    showDeviceImage,
    setShowDeviceImage,
    existsPrevPoint,
    existsNextPoint,
    selectPrevPoint,
    selectNextPoint,
    setStatusMsg,
    isEvent,
    msg,
    formattedAddress,
    isPinned
}) => (
    <div className={styles.PointDetailsHeaderCointainer}>
        <div className={styles.PointDetailsHeader}>
            <img
                className={styles.PointDetailsImage}
                src={deviceIconUrl ?? imagePathFallback}
                onClick={() => setShowDeviceImage(!showDeviceImage)}
            />

            <div className={styles.PointDetailsData}>
                <div className={styles.PointDetailsInfoContainer}>
                    {existsPrevPoint && (
                        <div className={styles.PointDetailsBtnContainer}>
                            <ChevronLeft
                                style={{ height: '16px', width: '16px' }}
                                onClick={() => {
                                    setStatusMsg('');
                                    selectPrevPoint && selectPrevPoint();
                                }}
                            />
                        </div>
                    )}

                    <span className={styles.PointDetailsName}>{deviceName}</span>

                    {existsNextPoint && (
                        <div className={styles.PointDetailsBtnContainer}>
                            <ChevronRight
                                style={{ height: '16px', width: '16px' }}
                                onClick={() => {
                                    setStatusMsg('');
                                    selectNextPoint && selectNextPoint();
                                }}
                            />
                        </div>
                    )}
                </div>

                {isEvent ? (
                    <span className={styles.PointDetailsMessage}>
                        Event:
                        <span style={{ fontWeight: 500 }}>{msg}</span>
                    </span>
                ) : (
                    <span className={styles.PointDetailsMessage}>
                        <MapPinIcon style={{ width: '12px', height: '12px' }} />
                        {formattedAddress}
                    </span>
                )}
            </div>
        </div>

        {isPinned && (
            <div className={styles.PointDetailsPinnedContainer}>
                <KeepIcon style={{ width: '12px', height: '12px' }} />
                <span>Pinned</span>
            </div>
        )}
    </div>
);